import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { SelectionCardComponent } from '@valk-nx/components/ui-selection-card/src/lib/selection-card';
import type { SelectionCardInterface } from '@valk-nx/components/ui-selection-card/src/lib/selection-card.interface';

import type { FiltersItemInterface } from '../../contracts/filters.interface';

@Component({
	selector: `vp-filter-layout`,
	templateUrl: './filter-layout.html',
	host: { class: 'contents' },
	imports: [SelectionCardComponent, TranslatePipe],
})
export class FilterLayoutComponent {
	title = input.required<string>();
	items = input<FiltersItemInterface[]>([]);
	activeValues = input<string[]>([]);

	changed = output<string[]>();

	protected readonly options = computed<SelectionCardInterface[]>(() =>
		this.items().map((item) => ({
			label: item.name,
			inputId: item.value,
			icon: item.icon
				? `assets/icons/layout-${item.icon}.svg`
				: undefined,
			selected: this.activeValues().includes(item.value),
		})),
	);

	onOptionsChange(options: SelectionCardInterface[]): void {
		this.changed.emit(
			options
				.filter((option) => option.selected)
				.map((option) => option.inputId),
		);
	}
}
